import React, { useContext, useState } from "react";
import location from "../../assets/line-md_my-location.png";
import { jobFilters } from "../../constant";
import { FunctionContext } from "../../context/FunctionProvider";

const FilterList = ({ header, filters,name }) => {
  const [show, setshow] = useState(false);
   const {
     searchSubmit,
     query,
   } = useContext(FunctionContext);
   const itemsArray = query[name]?.split(',').map(item => item.trim());
   console.log("itemsArray",itemsArray);
  const checked= (event)=>{
    let temp =query
    const check = event.target.checked;
    const key= event.target.name
    const value = event.target.value
  
    if (check) {
      temp[key]=temp[key]?temp[key]+","+value:value;
    }else{
      
      temp[key]=temp[key].replace(`,${value}`,'')
      temp[key]=temp[key].replace(`${value}`,'')
    }
    searchSubmit(temp,1)
 
  }
  return (
    <>
      <div className="filter-item">
        <p className="filter-header m-0">{header}</p>
        <ul class={`custom-list ${show ? "expand" : ""}`}>
          {filters?.map((element) => {
            if(itemsArray?.includes(element.label)&&(!show)){
    setshow(true)
            }
            return(
              <li>
              <input type="checkbox" checked={ itemsArray?.includes(element.label)} name={name} value={element.label}  onChange={(e)=>{checked(e)}}  /> {element.label}{" "}
              <span>{`(${element.count})`}</span>
            </li>
            )
           
         } )}
        </ul>
        <strong className={`view-more m-0 b-0 ${filters?.length<5?"no_allowed":""}`} onClick={() =>filters.length<5? "":setshow(!show)}>
          {show ? "View less" : "view more"}{" "}
        </strong>
      </div>
      <hr className="f-line m-0"></hr>
    </>
  );
};
function Filter() {
  const {t} = useContext(FunctionContext);
  return (
    <div className="filter">
      <div className="filterheader">
        <p className="filterheader-1 ">{t("filterheader")}</p>
        <hr className="f-line m-0"></hr>
        <p className="filterheader-2">{t("nearbywalkin")}</p>
        <button className="modern-button searchbutton  flex center near-b ">
          <img className="p img-m" alt='' src={location}></img>{" "}
          <p className="m-0 c p p-l-0 ">{t("comingsoon")}</p>
        </button>
        <hr className="f-line m-0"></hr>
        {jobFilters &&
          jobFilters?.map((element) => (
            <FilterList
              header={element.heading}
              filters={element.list}
              name={element.name
              }
            ></FilterList>
          ))}
      </div>
    </div>
  );
}

export default Filter;
